import { FieldHtmlNameUtil } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';

export default class ProDetails1SignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-pro-1of2';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    const hobbyIntentChosePro = this.sessionInfo.value.intent?.compareTo(UnifiedSignupIntent.funIntent)
      && this.sessionInfo.value.chosenPlan?.compareTo(UnifiedSignupPlan.pro);

    const extraFields: UnifiedSignupScreenComponent[] = [];
    if (hobbyIntentChosePro) {
      extraFields.push(
        new UnifiedSignupScreenComponent({
          displayField: this.getField(FieldHtmlNameUtil.doYouUseCadAtWork),
        }),
      );
    }

    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.companyName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.jobTitle),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.phoneNumber),
      }),
      ...extraFields,
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.levelOfInterestInNewCad).shuffleOptionList(),
      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const { chosenPlan, completedDetailsScreens } = this.sessionInfo.value;
    if (chosenPlan === null || !chosenPlan.compareTo(UnifiedSignupPlan.pro)) {
      return false;
    }

    if (completedDetailsScreens.length !== 0) {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.completedDetailsScreens.push(this.screenName);
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 75;
  }
}
